import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { PixelMessageBuilder } from '@websky/pixel';
import { sendPixelEvent } from '@shared/lib/pixel/sendPixelEvent';
import { useConfig } from '../../context';

const PixelPageViewWatcher: React.FC = () => {
	const {
		global: { usePixel }
	} = useConfig();

	if (!usePixel) {
		return null;
	}

	const location = useLocation();
	const prevLocation = useRef<string>(null);

	const handleLocationChange = async () => {
		const currentPath = window.location.href;
		const previousPath = prevLocation.current;

		if (currentPath !== previousPath) {
			await sendPixelEvent(cdpId =>
				PixelMessageBuilder.buildPageViewEvent(currentPath, previousPath ?? '', cdpId)
			);

			prevLocation.current = currentPath;
		}
	};

	useEffect(() => {
		handleLocationChange();
	}, [location, usePixel]);

	return null;
};

export default PixelPageViewWatcher;
